import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import { Search } from "lucide-react";
import DataTable from "react-data-table-component";
import "../../../../assets/css/my-Profile.css";
import Breadcrumbdasbord from "../../component/Breadcrumbdasbord";
import Sidebarmenu from "../../component/SidebarNavigation";
import { getHoldOrders, moveCart, } from "../../service/HoldOrder.service";

function HoldOrder() {
  const [holdOrders, setHoldOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [movingToken, setMovingToken] = useState(null);

  // ==========================
  // GET HOLD ORDERS
  // ==========================
  const loadHoldOrders = async () => {
    try {
      setLoading(true);
      const response = await getHoldOrders();
      console.log("HOLD ORDERS API:", response);
      if (response?.success && Array.isArray(response?.data)) {
        setHoldOrders(response.data);
      } else {
        setHoldOrders([]);
      }
    } catch (error) {
      console.error("Hold Orders Error:", error);
      setHoldOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHoldOrders();
  }, []);

  // ==========================
  // FLATTEN API DATA
  // ==========================
  const data = useMemo(() => {
    return holdOrders.map((item, index) => {
      const customer = item.cart_customers || {};
      const summary = item.cart_summary || {};
      const product = item.cart_items?.[0] || {};

      return {
        id: item.cart_temp_token || index,
        sno: index + 1,
        cartToken: item.cart_temp_token || "",
        customerName: customer.customer_name || "",
        image: product.design_shade_image || "",
        totalPrice:
          product.total_price ??
          summary.subtotal ??
          0,
      };
    });
  }, [holdOrders]);

  // ==========================
  // SEARCH
  // ==========================
  const filteredData = useMemo(() => {
    const value = search.toLowerCase().trim();

    if (!value) {
      return data;
    }

    return data.filter((item) => {
      return (
        item.customerName
          .toLowerCase()
          .includes(value) ||

        item.cartToken
          .toLowerCase()
          .includes(value)
      );
    });
  }, [data, search]);

  // ==========================
  // MOVE ORDER
  // ==========================
  const handleMove = async (row) => {
    try {
      if (!row.cartToken) {
        alert("Cart token not found");
        return;
      }

      setMovingToken(row.cartToken);

      await moveCart(
        row.cartToken,
        "fresh"
      );

      await loadHoldOrders();
    } catch (error) {
      console.error(
        "Move Order Error:",
        error
      );

      alert("Order move failed");
    } finally {
      setMovingToken(null);
    }
  };

  // ==========================
  // DATATABLE COLUMNS
  // ==========================
  const columns = [
    {
      name: "S.No.",
      selector: (row) => row.sno,
      width: "70px",
      center: true,
    },

    // {
    //   name: "Image",
    //   cell: (row) =>
    //     row.image ? (
    //       <img
    //         src={row.image}
    //         alt={row.designShade || "Product"}
    //         width="41"
    //         height="41"
    //         style={{
    //           objectFit: "cover",
    //           borderRadius: "6px",
              
    //         }}
    //       />
    //     ) : (
    //       "-"
    //     ),
    //   width: "90px",
    //   center: true,
    // },

    {
      name: "Customer Name",
      selector: (row) => row.customerName,
      sortable: true,
      minWidth: "220px",
    },

  
    {
      name: "Total",
      selector: (row) => row.totalPrice,
      sortable: true,
      cell: (row) =>
        `₹ ${Number(
          row.totalPrice
        ).toLocaleString("en-IN")}`,
      right: true,
      width: "130px",
    },

    {
      name: "Action",
      cell: (row) => (
        <button
          type="button"
          className="btn btn-primary btn-sm"
          title="Move Order"
          disabled={
            movingToken === row.cartToken
          }
          onClick={() =>
            handleMove(row)
          }
        >
          {movingToken === row.cartToken ? (
            <Spinner size="sm" />
          ) : (
            <i className="bi bi-send"></i> 
          )}
        </button>
      ),
      center: true,
      width: "100px",
    },
  ];

  // ==========================
  // CUSTOM DATATABLE STYLE
  // ==========================
const customStyles = {
  headRow: {
    style: {
      minHeight: "35px",
      backgroundColor: "#f4f5f5",
      borderBottom: "1px solid rgb(222, 226, 230)",
      borderTop: "1px solid rgb(222, 226, 230)",
    },
  },

  headCells: {
    style: {
      padding: "10px 12px",
      fontSize: "13px",
      fontWeight: "600",
      color: "#333",
      borderRight: "1px solid rgb(222, 226, 230)",
    },
  },

  rows: {
    style: {
      minHeight: "38px",
      fontSize: "13px",
      color: "#333",
      borderBottom: "1px solid #f1f1f1",
    },
  },
};

  return (
    <section className="profile-section">
      <div className="container-fluid">
        <Row>
          {/* SIDEBAR */}
            <Sidebarmenu />
          {/* CONTENT */}
          <Col lg={10} md={9}>

            <Breadcrumbdasbord
              title="Hold Order"
              items={[
                {
                  label: "Hold Order",
                  path: "/account/holdorder",
                },
              ]}
            />

            <div className="customer-wrapper">

              {/* SEARCH */}
              <div className="customer-header">

                <div className="search-box">

                  <Search size={18} />

                  <Form.Control
                    type="text"
                    placeholder="Search customer, product, barcode..."
                    value={search}
                    onChange={(e) =>
                      setSearch(e.target.value)
                    }
                    className="border-0 shadow-none"
                  />

                </div>

              </div>

              {/* DATATABLE */}
              <div className="table-card-box">

                <DataTable
                  columns={columns}
                  data={filteredData}
                  progressPending={loading}
                  progressComponent={
                    <div className="py-4">
                      <Spinner
                        size="sm"
                        className="me-2"
                      />
                      Loading Hold Orders...
                    </div>
                  }
                  noDataComponent={
                    <div className="py-4">
                      No Hold Order Found
                    </div>
                  }
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  highlightOnHover
                  pointerOnHover
                  responsive
                  striped
                  customStyles={customStyles}
                />

              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default HoldOrder;
